function isEmpty(val) {
    return val === null || typeof val == 'undefined' || val === '';
}